import React, { useState, useEffect, useContext } from "react";
import LogoIMG from "../../assets/app/Nav/LOGO-FONDO-NEGRO.png";
import LogoIMGLight from "../../assets/app/Nav/LOGO-FONDO-NEGRO-2.png";
import { useTranslation } from "react-i18next";

import "../../styles/app/ContactUsSection.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import ContactUsSlidderCard from "./ContactUsSlidderCard";
import DemoForm from "./DemoForm";
import { ThemeContext } from "../../contexts/ThemeContext";

const ContactUsSection: React.FC = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [chatIconUrl, setChatIconUrl] = useState<string | null>(null);

  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }

  const { isLightMode } = themeContext;

  useEffect(() => {
    const interval = setInterval(() => {
      const imgElement = document.querySelector(
        "#chat-toggle-btn img"
      ) as HTMLImageElement;
      if (imgElement && imgElement.src) {
        setChatIconUrl(imgElement.src);
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const opinions = [
    { stars: 5, text: t("contactUsSection.opinions.0.text") },
    { stars: 5, text: t("contactUsSection.opinions.1.text") },
    { stars: 5, text: t("contactUsSection.opinions.2.text") },
    { stars: 5, text: t("contactUsSection.opinions.3.text") },
    { stars: 5, text: t("contactUsSection.opinions.4.text") },
  ];

  return (
    <>
      <DemoForm show={showModal} onClose={() => setShowModal(false)} />
      <section
        className="contact-us-section"
        data-theme={isLightMode ? "light" : "dark"}
      >
        <div className="contact-us-container">
          <div className="contact-us-image">
            <img src={isLightMode ? LogoIMGLight : LogoIMG} alt="logo" />
          </div>
          <div className="contact-us-heading">
            <h1 className="contact-us-title">{t("contactUsSection.title")}</h1>
            <p className="contact-us-desc">
              {t("contactUsSection.description")}
            </p>
          </div>
          <div className="contact-us-btn-grid">
            <button
              className="contact-us-btn contact-us-call"
              onClick={() => setShowModal(true)}
            >
              {t("contactUsSection.scheduleCall")}
            </button>
            {/*
            <a
              className="contact-us-btn contact-us-whatsapp"
              href="https://wa.me/17866589428/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("contactUsSection.talkToAdvisor")}
            </a>
            */}
          </div>
          <div className="contact-us-attention">
            <p className="contact-us-attention-text">
              {t("contactUsSection.immediateAttention")}
            </p>
            <div className="contact-us-phone-container">
              {chatIconUrl && (
                <img
                  src={chatIconUrl}
                  alt="Chat Icon"
                  className="contact-us-chat-icon"
                />
              )}
              <div>
                <a
                  className="contact-us-attention-whatsapp"
                  href="tel:17862448828"
                  rel="noopener noreferrer"
                >
                  +1 (786) 244-8828
                </a>
              </div>
            </div>
            {/*}
            <div className="contact-us-attention-offer">
              <p className="contact-us-attention-offer-text">
                {t("contactUsSection.limitedOffer")}
              </p>
            </div>
            {*/}
          </div>
          {/*
          <div className="contact-us-slidder">
            <Swiper
              modules={[Pagination]}
              spaceBetween={30}
              slidesPerView={1}
              loop={true}
              pagination={{
                clickable: true,
              }}
            >
              {opinions.map((opinion, index) => (
                <SwiperSlide key={index}>
                  <ContactUsSlidderCard {...opinion} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          */}
        </div>
      </section>
    </>
  );
};

export default ContactUsSection;
